module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f07433_banner_800x600.1af7e9f3.png";